export interface CardItem {
  ProductId: number;
  ProductIdentityId: number;
  count: number;
  property: { attr: string; property: string }[];
}

interface TokenStoreState {
  cart: CardItem[];
  addCard: (newCard: CardItem) => void;
  deleteCard: (ProductIdentityId: number) => void;
  increaseCard: (ProductIdentityId: number) => void;
  decreaseCard: (ProductIdentityId: number) => void;
  removeCard: () => void;
}

import { create } from "zustand";

const loadStateFromLocalStorage = (): CardItem[] => {
  if (typeof window !== "undefined") {
    const stored = localStorage.getItem("shopping-cart");
    if (stored) {
      return JSON.parse(stored);
    }
  }
  return [];
};

const saveStateToLocalStorage = (cart: CardItem[]) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("shopping-cart", JSON.stringify(cart));
  }
};

export const useCardStore = create<TokenStoreState>((set, get) => ({
  cart: loadStateFromLocalStorage(),

  addCard: (newCard) => {
    set((state) => {
      const index = state.cart.findIndex(
        (item) => item.ProductIdentityId === newCard.ProductIdentityId
      );
      let newCart;
      if (index !== -1) {
        // Product exists, update count
        newCart = state.cart.slice();
        newCart[index] = {
          ...newCart[index],
          count: newCart[index].count + newCard.count,
        };
      } else {
        // New product, add to cart
        newCart = [...state.cart, newCard];
      }
      if (typeof window !== "undefined") {
        localStorage.setItem("shopping-cart", JSON.stringify(newCart));
      }
      return { cart: newCart };
    });
  },

  deleteCard: (ProductIdentityId) => {
    set((state) => {
      const newCart = state.cart.filter(
        (item) => item.ProductIdentityId !== ProductIdentityId
      );
      if (typeof window !== "undefined") {
        localStorage.setItem("shopping-cart", JSON.stringify(newCart));
      }
      return { cart: newCart };
    });
  },
  increaseCard: (ProductIdentityId) =>
    set((state) => {
      const newCart = state.cart.map((item) =>
        item.ProductIdentityId === ProductIdentityId
          ? { ...item, count: item.count + 1 }
          : item
      );
      saveStateToLocalStorage(newCart);
      return { cart: newCart };
    }),

  decreaseCard: (ProductIdentityId) =>
    set((state) => {
      const newCart = state.cart
        .map((item) =>
          item.ProductIdentityId === ProductIdentityId
            ? { ...item, count: Math.max(item.count - 1, 0) }
            : item
        )
        // Optionally, remove the item if the count drops to 0
        .filter((item) => item.count > 0);
      saveStateToLocalStorage(newCart);
      return { cart: newCart };
    }),
  removeCard: () => {
    set(() => {
      if (typeof window !== "undefined") {
        localStorage.setItem("shopping-cart", JSON.stringify([]));
      }
      return { cart: [] };
    });
  },
}));
